(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liveshow-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.liveshow-card');
  const modal = document.getElementById('videoModal');
  const closeBtn = modal.querySelector('.close');
  let video = document.getElementById('modalVideo');
  let currentIndex = 0;

  function openModal(index) {
    const videoUrl = cards[index].querySelector('.liveshow-thumb').dataset.video;
    const modalContent = modal.querySelector('.modal-content');
    const oldVideo = modal.querySelector('video, iframe');
    if (oldVideo) oldVideo.remove();

    if (videoUrl.includes('youtube') || videoUrl.includes('vimeo')) {
      const iframe = document.createElement('iframe');
      iframe.src = videoUrl;
      iframe.frameBorder = '0';
      iframe.allowFullscreen = true;
      iframe.style.width = '100%';
      iframe.style.height = '85vh';
      modalContent.appendChild(iframe);
    } else {
      const newVideo = document.createElement('video');
    newVideo.id = 'modalVideo';
    newVideo.src = videoUrl;
    newVideo.controls = true;
    newVideo.autoplay = true;
    newVideo.playsInline = true; // ✅ enables native controls inside modal
    newVideo.webkitPlaysInline = true; // ✅ for Safari iOS
    newVideo.muted = false;
    newVideo.style.width = '100%';
    newVideo.style.height = '85vh';
    newVideo.style.objectFit = 'contain';
    modalContent.appendChild(newVideo);
    video = newVideo;

    }

    modal.style.display = 'flex';
    currentIndex = index;
  }

  function closeModal() {
    modal.style.display = 'none';
    const currentMedia = modal.querySelector('video, iframe');
    if (currentMedia) currentMedia.remove();
  }

  cards.forEach((card, index) => {
    card.addEventListener('click', () => openModal(index));
  });

  closeBtn.addEventListener('click', closeModal);
  window.addEventListener('click', e => {
    if (e.target === modal) closeModal();
  });
});

  } catch(e) { console.error(e); }
})();
})();
